<div class="warning">
  <div class="padd15">
    <img width="250" alt="Thomson Reuters" class="" src="../../assets/img/Thomson-Reuters-logo.svg">
    <h1></h1>
    <div class="annoying-warning">
      <h2 class="AccessDeniedHeading ">{{Heading}}</h2>
      <p class="Information">{{Information}}</p>
    </div>
  </div>
</div>
